import { Control, FieldPath, FieldValues } from 'react-hook-form'

import { Input } from '../input'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '.'

interface FormInputProps<T extends FieldValues> extends React.InputHTMLAttributes<HTMLInputElement> {
    control: Control<T>
    name: FieldPath<T>
    label?: React.ReactNode
    inputClassName?: string
}

export default function FormInput<T extends FieldValues>({
    control,
    name,
    label,
    className,
    onChange,
    ...props
}: FormInputProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormLabel>{label}</FormLabel>
                    <FormControl>
                        <Input
                            {...props}
                            {...field}
                            onChange={e => {
                                field.onChange(e)
                                onChange?.(e)
                            }}
                        />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
